import React from "react";
import { connect } from "react-redux";

import GroheMobile3dButton from "./groheMobile3dButton";
import FeatureDescription from "../../../../visComponents/featureDescription";
import LookFeaturePairPrice from "../../../lookNavigation/lookMain/lookListFeature/lookFeaturePairPrice";
import GroheFeatureQuantity from "../../groheNavigation/groheFeature/groheFeatureQuantity";
import LookFeatureOptions from "../../../lookNavigation/lookMain/lookFeature/lookFeatureOptions";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import LookFeatureRemoveButton from "../../../lookNavigation/lookMain/lookFeatureRemoveButton";
import GroheFeatureSoldOut from "../../groheNavigation/groheFeature/groheFeatureSoldOut";
import {isInStock} from "../../../lookNavigation/lookFunctions2";
import GroheMobileFeatureTop from "./groheMobileFeatureTop";
import GroheFeatureMoreInfoButton from "../../groheNavigation/groheFeature/groheFeatureMoreInfoButton";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import GroheFeatureOptions from "../../groheNavigation/groheFeature/groheFeatureOptions";
import GroheFeatureSQFTButton from "../../groheNavigation/groheFeature/groheFeatureSQFTButton";
import {categoryIsInTheWizard} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import GroheFeatureWizardButton from "../../groheNavigation/groheFeature/groheFeatureWizardButton";

const GroheMobileFeature = (props) => {

  const {lookActiveFeature, wizardActiveItem, wizardList, activePreset} = props;

  if (!lookActiveFeature || wizardActiveItem) {
    return null
  }

  const disabled = !isInStock(lookActiveFeature);
  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);

  const hasWizard = !wizardActiveItem
    && categoryIsInTheWizard(wizardList, lookActiveFeature.partId, activePreset);

  return (
    <div className={"gm-feature" + (featureIsLocked ? " grohe-feature--locked" : "")}>
      <GroheMobileFeatureTop/>
      {hasWizard ? <GroheFeatureWizardButton feature={lookActiveFeature} hasWizard={hasWizard}/> : null}
      <div className="lm-feature__content-description">
        <FeatureDescription feature={lookActiveFeature} brief={true}/>
      </div>
      <div className="lk-feature__price">
        <span className="lk-title lk-price">
          <LookFeaturePairPrice lookFeature={lookActiveFeature}/>
        </span>
        <GroheFeatureMoreInfoButton/>
      </div>
      <GroheFeatureSoldOut disabled={disabled}/>
      <div className="lk-feature__calculate">
        <GroheFeatureQuantity disabled={disabled}/>
        <GroheFeatureSQFTButton featureOpened={lookActiveFeature} isIcon={true} className="look-icon--ml-12" />
      </div>
      <GroheFeatureOptions/>
      <LookFeatureOptions/>
      <div className="gm-feature__bottom">
        <GroheMobile3dButton/>
        <LookFeatureImage/>
      </div>
      <div className="gm-feature__checkbox">
        <LookFeatureRemoveButton lookFeature={lookActiveFeature} isToggle={true}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened, lookActiveFeature} = store.lookState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {wizardActiveItem, wizardList} = store.wizardState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    lookOpened,
    lookActiveFeature,
    isPhoneNumberValidated,
    wizardActiveItem,
    wizardList,
    activePreset,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(GroheMobileFeature)
